var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { addEventListener } from '@ifeng-fe/ui_base';
import { formatUrl } from '@ifeng-fe/public_method';
import { styleName } from '../utils/utils';
import { isThreeImage, isOneImage, haveImage } from '../utils/newsStream';
import Basic from '../Basic/Basic';
import OneImage from './components/OneImage';
import ThreeImage from './components/ThreeImage';
import NoImage from './components/NoImage';
import BigImage from './components/BigImage';
/* 信息流 */
var NewsStream = /** @class */ (function (_super) {
    __extends(NewsStream, _super);
    function NewsStream(props) {
        var argu = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            argu[_i - 1] = arguments[_i];
        }
        var _this = _super.apply(this, __spreadArrays([props], argu)) || this;
        var _a = _this.props, content = _a.content, isEnd = _a.isEnd;
        _this.countMap = {}; // 文章评论数，渲染list后清空
        _this.state = {
            oldContent: content,
            content: content,
            isEnd: isEnd,
            isLoading: false,
            countMapCache: {} // 缓存评论
        };
        if (_this.props.isScrollLoadingData) {
            _this.unlistenerHandleWindowScroll = addEventListener(window, 'scroll', _this.handleWindowScroll);
        }
        return _this;
    }
    NewsStream.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, item;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.props.isCount) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getCount()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!(this.props.ad && this.props.ad.length > 0)) return [3 /*break*/, 6];
                        _i = 0, _a = this.props.ad;
                        _b.label = 3;
                    case 3:
                        if (!(_i < _a.length)) return [3 /*break*/, 6];
                        item = _a[_i];
                        return [4 /*yield*/, this.getAd(item)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 3];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    // 渲染list
    NewsStream.prototype.listView = function (list) {
        var _this = this;
        this.countMap = {};
        var endIndex = list.length - 1;
        var id = [];
        var _a = this.props, isDisplaySource = _a.isDisplaySource, isPic = _a.isPic, isCount = _a.isCount, cutImage = _a.cutImage, searchPathMap = _a.searchPathMap;
        var countMapCache = this.state.countMapCache;
        return list.map(function (item, index) {
            // 渲染广告
            if (item.type === 'ad')
                return React.createElement("li", { key: index, ref: item.ref, className: styleName('newsStream-news-item-ad') });
            // 获取最后一位的信息，用于加载信息流
            if (index === endIndex)
                _this.lastItem = item;
            // 和推荐位或信息流本身的id去重
            if (_this.props.repeatedID.includes(item.id) || id.includes(item.id))
                return null;
            // 将已渲染id加入到数组
            id.push(item.id);
            // 评论
            if (!(item.id in _this.state.countMapCache)) {
                _this.countMap[item.id] = index;
            }
            // 评论地址
            var url = formatUrl(item.url); // 格式化url
            var query = "docUrl=" + (item.commentUrl || item.guid) + "&docName=" + item.title + "&skey=" + item.skey + "&pcUrl=" + item.url;
            var pinglunUrl = "https://gentie.ifeng.com/view.html?" + query;
            var props = { item: item, url: url, pinglunUrl: pinglunUrl, isDisplaySource: isDisplaySource, isCount: isCount, countMapCache: countMapCache, cutImage: cutImage, searchPathMap: searchPathMap };
            var key = item.id + "_" + item.creator + "_" + item.newsTime;
            // 兼容图片的解析
            var thumbnails = item.thumbnails;
            if (thumbnails && typeof thumbnails === 'string' && thumbnails !== '') {
                try {
                    thumbnails = JSON.parse(thumbnails);
                }
                catch (err) {
                    thumbnails = undefined;
                }
            }
            // 大图模式
            if (isPic)
                return React.createElement(BigImage, __assign({ key: key, thumbnails: thumbnails }, props));
            // 类型为视频或图集时优先以一图模式显示，否则为无图
            if ((item.type === 'video' || item.videoCount || item.type === 'slide') && haveImage(thumbnails)) {
                return React.createElement(OneImage, __assign({ key: key, thumbnails: thumbnails }, props));
            }
            // 三图模式
            if (isThreeImage(thumbnails))
                return React.createElement(ThreeImage, __assign({ key: key, thumbnails: thumbnails }, props));
            // 一图模式
            if (isOneImage(thumbnails))
                return React.createElement(OneImage, __assign({ key: key, thumbnails: thumbnails }, props));
            // 无图模式
            return React.createElement(NoImage, __assign({ key: key }, props));
        });
    };
    NewsStream.prototype.render = function () {
        var _a = this.props, moreElement = _a.moreElement, isDisplayLoadingMore = _a.isDisplayLoadingMore;
        var _b = this.state, content = _b.content, isLoading = _b.isLoading;
        if (content.length === 0) {
            return (React.createElement("div", null, isDisplayLoadingMore ? (React.createElement("div", { className: styleName('newsStream-more-box') },
                React.createElement("span", { className: styleName('basic-is-end') }, "\u6682\u65E0\u6570\u636E"))) : null));
        }
        else {
            return (React.createElement("div", null,
                React.createElement("ul", { ref: this.listRef, className: styleName('basic-news-list') }, this.listView(content)),
                isDisplayLoadingMore ? (React.createElement("div", { className: styleName('newsStream-more-box') }, moreElement ? moreElement : (isLoading ? React.createElement("span", { className: styleName('basic-is-end') }, "\u52A0\u8F7D\u4E2D...") : this.moreView()))) : null));
        }
    };
    NewsStream.propTypes = {
        content: PropTypes.array,
        isDisplaySource: PropTypes.bool,
        columnId: PropTypes.any,
        isEnd: PropTypes.bool,
        repeatedID: PropTypes.array,
        isScrollLoadingData: PropTypes.bool,
        isPic: PropTypes.bool,
        isDisplayLoadingMore: PropTypes.bool,
        isCount: PropTypes.bool,
        moreHref: PropTypes.string,
        moreElement: PropTypes.node,
        cutImage: PropTypes.object,
        ad: PropTypes.arrayOf(PropTypes.object),
        urlId: PropTypes.string,
        dataTypeName: PropTypes.string,
        searchPathMap: PropTypes.object,
        handleLoadingDataFunc: PropTypes.func // 自定义加载更多函数
    };
    NewsStream.defaultProps = {
        isDisplaySource: true,
        isEnd: false,
        repeatedID: [],
        isScrollLoadingData: false,
        isPic: false,
        isDisplayLoadingMore: true,
        isCount: true,
        urlId: '_',
        dataTypeName: 'default',
        searchPathMap: {}
    };
    return NewsStream;
}(Basic));
export default NewsStream;
